'use strict';
exports.opening = require('./opening');
exports.closing = require('./closing');



//////////////////
// WEBPACK FOOTER
// ./~/hast-util-to-html/lib/omission/index.js
// module id = 172
// module chunks = 94053359063892 107818501498521